import api from '@/api';
import localConfig from '@/config';
import { normalizeParamsObject } from 'shared-lib/helpers/formatters';

const types = {
    SAVE_FILTERS: 'SAVE_BANNERS_FILTERS',
    RESET_FILTERS: 'RESET_BANNERS_FILTERS',
    RECEIVE_LIST: 'RECEIVE_BANNERS',
    RECEIVE_FOLDER_LIST: 'RECEIVE_BANNERS_FOLDERS',
    RECEIVE_FOLDER_LIST_ALL: 'RECEIVE_BANNERS_FOLDERS_ALL',
    UPDATE_BANNER_FOLDER: 'UPDATE_BANNER_FOLDER',
    BANNERFOLDERS_INLINE_EDIT_ON: 'BANNERFOLDERS_INLINE_EDIT_ON',
    BANNERFOLDERS_INLINE_EDIT_OFF: 'BANNERFOLDERS_INLINE_EDIT_OFF',
};

const initialState = {
    filters: {
        offset: 0,
        limit: localConfig.defaultListLimit,
        sort: '-created',
    },
    data: {
        data: [],
        meta: {},
    },
    folders: {
        data: [],
        meta: {},
    },
    foldersAll: [],
};

const state = {
    ...initialState,
};


const getters = {
    bannersData:       state => ({
        data: state.data.data ? state.data.data.map(banner => {
            banner.dimension = `${banner.width} x ${banner.height}`;
            return banner;
        }) : [],
        meta: state.data.meta ? state.data.meta : [],
        filters: state.filters,
    }),
    bannerFoldersData: state => ({
        ...state.folders,
        filters: state.filters,
    }),
    bannerFoldersDataAll: state => state.foldersAll,
};


const actions = {
    saveBannersFilters ({ commit }, payload) {
        commit(types.SAVE_FILTERS, { payload });
    },
    resetBannersFilters ({ commit }) {
        commit(types.RESET_FILTERS);
    },
    getBanners ({ commit }) {
        return api.banners.list(state.filters).then((response) => {
            commit(types.RECEIVE_LIST, { response });
        });
    },
    getBannerFolders ({ commit }) {
        // TODO: unify payload/params
        return api.banners.groupedList({ ...state.filters }).then((response) => {
            commit(types.RECEIVE_FOLDER_LIST, { response });
        });
    },
    getBannerFoldersAll ({ commit }, payload) {
        return api.bannerFolders.list({ ...payload, limit: -1 }).then((response) => {
            commit(types.RECEIVE_FOLDER_LIST_ALL, {
                response,
            });
        });
    },
    updateBannerFolder ({ commit }, payload) {
        return Promise.resolve(
            api.bannerFolders.update(payload.id, payload).then((response) => {
                if (response.data) {
                    commit(types.UPDATE_BANNER_FOLDER, { response, body: payload });
                }

                return payload.name;
            }));
    },
};


const mutations = {
    [types.SAVE_FILTERS] (state, { payload }) {
        let payloadNormalized = normalizeParamsObject(payload);

        state.filters = { ...payloadNormalized };
    },
    [types.RECEIVE_LIST] (state, { response }) {
        state.data = response.data;
    },
    [types.RECEIVE_FOLDER_LIST] (state, { response }) {
        state.folders = response.data;
    },
    [types.RECEIVE_FOLDER_LIST_ALL] (state, { response }) {
        state.foldersAll = response.data.data;
    },
    [types.BANNERFOLDERS_INLINE_EDIT_ON] (state, folderId) {
        state.folders = Object.assign({}, {
            meta: state.folders.meta,
            data: Object.assign(state.folders.data, state.folders.data.find(folder => {
                return (folder.folder_id === folderId && (folder.inlineEditMode = true));
            })),
        });
    },
    [types.BANNERFOLDERS_INLINE_EDIT_OFF] (state, folderId) {
        state.folders = Object.assign({}, {
            meta: state.folders.meta,
            data: Object.assign(state.folders.data, state.folders.data.find(folder => {
                return (folder.folder_id === folderId && (folder.inlineEditMode = false));
            })),
        });
    },
    [types.UPDATE_BANNER_FOLDER] (state, { body, response }) {
        state.folders = Object.assign({}, {
            meta: state.folders.meta,
            data: Object.assign(state.folders.data, state.folders.data.find(folder => {
                return (folder.folder_id === response.data.data.id && (folder.folder_name = body.name));
            })),
        });
    },
    [types.RESET_FILTERS] (state) {
        state.filters = { ...initialState.filters };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
